import { USER_KPI_ROUTE_ID } from './common';

// Import directly instead of lazy loading to prevent full-page loader flash
import UserKpiManagement from './components/UserKpiManagement';

export const kpiUserKpiRoutes = {
    [USER_KPI_ROUTE_ID]: () => <UserKpiManagement />
};
